import React, { useEffect } from 'react';

import { ArrowBarLeft, ArrowBarRight } from 'react-bootstrap-icons';
import { toggledSidebar } from '../../../Store/App/action';
import { useDispatch } from 'react-redux';
import useGetSidebarIsOpened from '../../../Hook/Interest/UseGetSidebarIsOpened';

const SidebarToggler: React.FC = () => {
    const dispatch = useDispatch();

    const sidebarOpened = useGetSidebarIsOpened();

    useEffect(() => {
        document.body.classList.toggle('sidebar-hidden', !sidebarOpened);
    }, [sidebarOpened]);

    return (
        <>
            {sidebarOpened && <ArrowBarLeft className="sidebar-toggler" onClick={() => dispatch(toggledSidebar())} />}
            {!sidebarOpened && <ArrowBarRight className="sidebar-toggler" onClick={() => dispatch(toggledSidebar())} />}
        </>
    );
};

export default SidebarToggler;
